export default function Logo({ className = 'h-8', variant }) {
  return <img src={variant === 'white' ? '/logo_white.svg' : '/logo.svg'} alt="Droid" className={className} />;
}
